import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { get } from "jquery";
import { BASE_URL, BDM_FOLLOW_UP_TASKS, BDM_SELF_TASKS } from "../../constants";
import axios from "axios";
import TaskListModal from "./TaskListModal";
import BdmListofTasks from "./BdmListOfTasks";
import LeaveComponent from "./LeaveComponent";
import HolidayComponent from "./HolidayComponent";
import { PhoneIphone } from "@mui/icons-material";
import { useTheme } from "@emotion/react";
import { BookCheck, Clipboard, Clock, MapPinned, TreePalm } from "lucide-react";
import ConnectProLogo from "../../icons/abis_connect_pro_logo.png";

const BdmTaskTypeComponent = () => {
  const navigate = useNavigate();
  const storedId = localStorage.getItem("username");
  const storedRole = localStorage.getItem("empRole");

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [openTasktype, setOpenTasktype] = useState(true);
  const [openTaskListModal, setOpenTaskListModal] = useState(false);

  const [initialHoTask, setInitialHoTask] = useState([]);
  const [initialSelfTask, setInitialSelfTask] = useState([]);

  const fetchInitialFollowupTask = async () => {
    try {
      const response = await axios.get(`${BDM_FOLLOW_UP_TASKS}${storedId}`);
      const { Ho_task } = response.data;
      setInitialHoTask(Ho_task);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const fetchInitialSelfTask = async () => {
    try {
      const response = await axios.get(`${BDM_SELF_TASKS}${storedId}`);
      const { self_task } = response.data;
      setInitialSelfTask(self_task);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    fetchInitialFollowupTask();
    fetchInitialSelfTask();
  }, []);

  const handleCloseDialog = () => {
    setOpenTaskListModal(false);
  };

  const [openLeaveModal, setOpenLeaveModal] = useState(false);

  const handleCloseLeaveModal = () => {
    setOpenLeaveModal(false);
  };

  const [openHolidayModal, setOpenHolidayModal] = useState(false);

  const handleCloseHolidayModal = () => {
    setOpenHolidayModal(false);
  };

  return (
    <>
      <Dialog open={openTasktype} fullScreen>
        <DialogTitle>Choose Your Task Type</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              padding: "16px",
              backgroundColor: "#EEF0F4",
              borderRadius: "8px",
              marginBottom: "16px",
              // Change background color for mobile screens
              backgroundColor: {
                xs: "#fff", // Light grey for mobile
                sm: "#EEF0F4", // Default for larger screens
              },
            }}
          >
            <Grid container spacing={2}>
              {isMobile && (
                <Grid item xs={12} sm={6} md={3}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "16px",
                      borderRadius: "8px",
                      height: "120px",
                      cursor: "pointer",
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: "#fff", // Circle background color
                        borderRadius: "50%", // Makes it circular
                        padding: "15px", // Adjust size of the circle (controls spacing around the icon)
                        marginBottom: "8px", // Space between the icon and the text
                      }}
                    >
                      {/* Icon on top */}
                      <img src={ConnectProLogo} style={{ width: "7rem" }}></img>
                      {/* <BookCheck size={50} /> */}
                    </Box>
                  </Box>
                </Grid>
              )}

              {/* To-Do List */}
              <Grid item xs={12} sm={6} md={3}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "16px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                    boxShadow: 2,
                    height: "120px",
                    cursor: "pointer",
                    transition: "background-color 0.3s ease", // Smooth transition
                    "&:hover": {
                      backgroundColor: "#e0e0e0", // Darken on hover
                    },
                    "&:active": {
                      backgroundColor: "#d0d0d0", // Darker shade on click
                    },
                  }}
                  onClick={() => {
                    if(storedRole === "500"){
                      navigate("/bdmtodo");
                    } else {
                      setOpenTaskListModal(true);
                    }
                  }}
                >
                  {/* Icon on top */}
                  <Clock size={35} style={{ marginBottom: 1 }} />
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bold", color: "#333" }}
                  >
                    Attendance In
                  </Typography>
                </Box>
              </Grid>

              {/* Holiday */}
              {/* <Grid item xs={12} sm={6} md={3}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "16px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                    boxShadow: 2,
                    height: "120px",
                    transition: "background-color 0.3s ease", // Smooth transition
                    "&:hover": {
                      backgroundColor: "#e0e0e0", // Darken on hover
                    },
                    "&:active": {
                      backgroundColor: "#d0d0d0", // Darker shade on click
                    },
                  }}
                  onClick={() => setOpenHolidayModal(true)}
                >
                  
                  <TreePalm size={35} style={{ marginBottom: 1 }} />
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bold", color: "#333" }}
                  >
                    Holiday
                  </Typography>
                </Box>
              </Grid> */}

              {/* Leave */}
              <Grid item xs={12} sm={6} md={3}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "16px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                    boxShadow: 2,
                    height: "120px",
                    transition: "background-color 0.3s ease", // Smooth transition
                    "&:hover": {
                      backgroundColor: "#e0e0e0", // Darken on hover
                    },
                    "&:active": {
                      backgroundColor: "#d0d0d0", // Darker shade on click
                    },
                  }}
                  onClick={() => setOpenLeaveModal(true)}
                >
                  {/* Icon on top */}
                  <Clipboard size={35} style={{ marginBottom: 1 }} />
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bold", color: "#333" }}
                  >
                    Leave
                  </Typography>
                </Box>
              </Grid>

              {/* Regional Holiday */}
              {/* <Grid item xs={12} sm={6} md={3}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "16px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                    boxShadow: 2,
                    height: "120px",
                    transition: "background-color 0.3s ease", // Smooth transition
                    "&:hover": {
                      backgroundColor: "#e0e0e0", // Darken on hover
                    },
                    "&:active": {
                      backgroundColor: "#d0d0d0", // Darker shade on click
                    },
                  }}
                  onClick={() => setOpenHolidayModal(true)}
                >
                  
                  <MapPinned size={35} style={{ marginBottom: 1 }} />
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bold", color: "#333" }}
                  >
                    Regional Holiday
                  </Typography>
                </Box>
              </Grid> */}
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>

      <BdmListofTasks
        open={openTaskListModal}
        onClose={handleCloseDialog}
        initialHoTask={initialHoTask}
        setInitialHoTask={setInitialHoTask}
        initialSelfTask={initialSelfTask}
        setInitialSelfTask={setInitialSelfTask}
      ></BdmListofTasks>

      <LeaveComponent
        open={openLeaveModal}
        onClose={handleCloseLeaveModal}
        pageType={''}
      ></LeaveComponent>

      <HolidayComponent
        open={openHolidayModal}
        onClose={handleCloseHolidayModal}
      ></HolidayComponent>
    </>
  );
};

export default BdmTaskTypeComponent;
